module.exports = __webpack_public_path__ + "static/img/124.8X60.693b25ce.jpg";